import ErrorHandler from 'common/error/components/error-handler';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Table from '../../../common/table/table';
import Tags from '../../../common/tags/components/tags';
import { announcementBannerHeight } from '../../../utils/app-configs';
import { fetchSkills, fetchSkillsNext, updateSkill } from '../../containers/skills/skills-actions';
import SkillsToolbar from './skills-toolbar';

const Wrapper = styled.div`
  width: calc(100% + 40px);
  margin-left: -20px;
`;

const Fse = ({ intl }) => {
  const dispatch = useDispatch();
  const {
    isLoadingSkills,
    isLoadingSkillsNext,
    skillsError,
    skills,
    isUpdatingSkill,
  } = useSelector(state => state.skills);
  const { hasAnnouncementBanner } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchSkills());
  }, []);

  const handleUpdate = (id, tags = [], v, isAdd) => {
    const newTags = isAdd ?
      [
        ...tags?.map(s => ({
          scope: s?.scope,
          skillNumber: s?.skillNumber,
          level: s?.level,
        })),
        ...skills?.technicianSkillList?.filter(s => s.id === v)
          ?.map(s => ({
            scope: s?.scope,
            skillNumber: s?.skillNumber,
            level: s?.level,
          })),
      ] : tags?.filter(f => f.id !== v);
    dispatch(updateSkill({
      id,
      assignedSkills: newTags,
      originalSkills: tags,
    }));
  };

  const fetchMore = (page) => {
    if (!isLoadingSkills && !isLoadingSkillsNext && skills?.next) {
      dispatch(fetchSkillsNext({ page }));
    }
  };

  const columns = [{
    id: 'fse',
    displayName: intl.formatMessage({ id: 'skills.FSE' }),
    fieldName: 'name',
    width: '250px',
    tooltip: row => row.name,
  },
  {
    id: 'skills',
    displayName: intl.formatMessage({ id: 'skills.SKILLS' }),
    renderFn: (d) => {
      const selectedTags = (d?.assignedSkills || [])?.map(s => ({
        id: s.id,
        description: s?.fullDescription ||
          intl.formatMessage({ id: 'skills.NO_DESCRIPTION' }),
      }));
      const allTags = skills?.technicianSkillList ?
        Object.values(skills?.technicianSkillList)
          ?.filter(({ id }) => (d.applicableSkills || [])
            ?.find(f => f?.id === id))
          ?.map(({ id, fullDescription }) => ({
            id,
            description: fullDescription,
          })) :
        [];
      return <Tags
        selectedTags={selectedTags}
        allCategoryTags={allTags}
        initialSelectedTags={selectedTags}
        name='skillTags'
        tagTextColor='blue'
        addIdToDescription={false}
        showFullDescription={true}
        addTagCallback={e => handleUpdate(d?.id, d?.assignedSkills, e, true)}
        removeTagCallback={e => handleUpdate(d?.id, d?.assignedSkills, e, false)}
        disabled={isUpdatingSkill}
        dropdownPlacement='bottomRight'
        useBodyAsParent={true}
      />;
    },
  }];
  const offsetHeight = hasAnnouncementBanner ? 305 + announcementBannerHeight : 305;
  return <>
    <ErrorHandler type='notification' error={skillsError} />
    <SkillsToolbar />
    <Wrapper>
      <Table
        columns={columns}
        data={skills?.data || []}
        fullWidth={true}
        // height of table should be 100% minus the height of all headers & toolbars
        // (5 * 55px + 30px)
        height={`calc(100vh - ${offsetHeight}px)`}
        isLoadingData={isLoadingSkills}
        infiniteScroll={true}
        loadMore={fetchMore}
        totalDataCount={skills?.totalDataCount ?? 0}
        showFullValue={true}
      />
    </Wrapper>
  </>;
};

Fse.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(Fse);
